
































































import Vue from 'vue';
import * as api from '@/api';
import CardContainer from '@/components/CardContainer.vue';
import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import CardTable from './CardTable.vue';

export default Vue.extend({
    components: {
        CardTable,
        DownloadDia,
        CardContainer,
    },
    name: 'UserUpdate',
    data() {
        return {
            dataLoading: true,
            search: '',
            updateProductList: [] as api.ProductListItem[],
            fileTypes: [],
            dialogVisible: {
                show: false,
            },
        };
    },
    async created() {
        this.getUserProductsToBeUpdated();
    },
    methods: {
        downLoadSuccess(status) {
            if (status) {
                this.getUserProductsToBeUpdated();
                this.$store.dispatch('getUserSummary');
            }
        },
        async getUserProductsToBeUpdated() {
            this.dataLoading = true;
            const res = await api.getUserProductsToBeUpdated();
            if (!api.error(res)) {
                this.updateProductList = res.data.filter((data) => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()));
            }
            this.dataLoading = false;
        },
        async update(item) {
            const isLoginRes = await api.isLogined();
            if (!api.error(isLoginRes)) {
                this.$store.commit('currentProductInfo', {
                    id: item.productId,
                    pvId: item.pvId,
                    name: item.name,
                });
                const fileTypes = await api.getFileTypes({ id: item.productId, pvId: item.pvId });
                if (!api.error(fileTypes)) {
                    fileTypes.data.length === 0 && this.$message({ type: 'info', message: '暂无模型文件可供下载' });
                    fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
                }
            }
        },
        navToProductDetail(product) {
            // this.$store.commit('currentProductInfo', product);
            const path = `/product/${product.productId}`;
            const { href } = this.$router.resolve({
                path,
            });
            window.open(href, '_blank');
        },
        navToBrandDetail(product) {
            this.$router.push({
                path: `/brand/${product.brandId}`,
            });
        },
    },
});
